module.exports = __webpack_public_path__ + "static/media/26.d686534d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/26.jpg
// module id = 716
// module chunks = 0